export default __webpack_public_path__ + "static/media/image-ph-study-report-n-m@2x.cb39cfd5.png";